import { Box } from "@mui/material";
import { cateogriesMenu } from "data/constants";
import useQueryParams from "hooks/useQueryParams";
import { useNavigate } from "react-router-dom";
import { StyledProfileNav, StyledProfileNavItem } from "views/clients/styles";
import ServiceCateogries from "./serviceCateogries";
import ClientCateogries from "./clientCateogries";

function Cateogries() {
  const navigate = useNavigate();
  const { queryParams } = useQueryParams();
  const active = queryParams.tab || "Service Categories";

  return (
    <>
      <Box sx={{ position: "sticky", top: 65, bgcolor: "white", zIndex: 2 }}>
        <StyledProfileNav>
          {cateogriesMenu.map((item, index) => (
            <StyledProfileNavItem
              key={index}
              onClick={() => navigate(`?tab=${item.title}`)}
              active={active === item.title ? 1 : 0}
            >
              {item.title}
            </StyledProfileNavItem>
          ))}
        </StyledProfileNav>
      </Box>
      <Box px={2} pb={0} mb={0}>
        {active === "Service Categories" && <ServiceCateogries />}
        {active === "Client Categories" && <ClientCateogries />}
      </Box>
    </>
  );
}

export default Cateogries;
